(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@scuf/localization"), require("@scuf/common"));
	else if(typeof define === 'function' && define.amd)
		define("@EMaaS/EMaaS.consup.react.widget.energymanagement", ["react", "@scuf/localization", "@scuf/common"], factory);
	else if(typeof exports === 'object')
		exports["@EMaaS/EMaaS.consup.react.widget.energymanagement"] = factory(require("react"), require("@scuf/localization"), require("@scuf/common"));
	else
		root["@EMaaS/EMaaS.consup.react.widget.energymanagement"] = factory(root["react"], root["@scuf/localization"], root["@scuf/common"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__8156__, __WEBPACK_EXTERNAL_MODULE__60834__, __WEBPACK_EXTERNAL_MODULE__84705__) => {
return 